import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

import {IMyDateModel} from 'mydatepicker';

import {AppComponent} from './app.component';

import {PlacementService} from './placement.service';

@Component({
    selector: 'placement-docket',
    templateUrl: './templates/placement-docket.component.html',
    styleUrls: ['./styles/products-list.component.css', './styles/placement-docket.component.css'],
    providers: [PlacementService]
})
export class PlacementDocketComponent implements OnInit {

    @Input() docket_list: Array<any> = [];
    @Output() docket_to_send = new EventEmitter();

    docket_name: string = "";
    docket_date: string = "";

    operation_bt: string = "Placer";

    constructor(
        private app_component: AppComponent,
        private placement_service: PlacementService,
    ) {}

    ngOnInit() {
        this.SearchDockets();
    }

    Place(docket: any) {
        this.docket_to_send.emit(docket);
    }

    SearchDockets(): void {
        this.placement_service.SearchDockets(this.docket_name, this.docket_date)
            .then(response => {
                this.docket_list = response['list'];
            });
    }

    onDateChanged(event: IMyDateModel) {
        if (event.jsdate === null) {
            this.docket_date = "";
        } else {
            this.docket_date = event.jsdate.toLocaleDateString("en-US");
        }
        this.SearchDockets();
    }

}



// WEBPACK FOOTER //
// ./src/app/placement-docket.component.ts